export const ALL_PRODUCT = "ALL_PRODUCT";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const RESET_LOADING = "RESET_LOADING";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const ERROR = "ERROR";
